import React from 'react';
import './InUseModal.css';

export const InUseModal = ({isOpen, onClose, userName, isHqUser, onKillSession, killingSession}) =>
{
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content in-use-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Inventory In Use</h2>
          <button
            className="modal-close"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <p className="in-use-message">
            You cannot manage this inventory now. It is currently being managed by <strong>{userName}</strong>.
          </p>
          {!isHqUser && (
            <p className="in-use-warning-message">
              Please wait until they finish or contact them to release the inventory.
            </p>
          )}
        </div>

        <div className="modal-footer">
          {isHqUser && (
            <button
              className="btn-kill-session"
              onClick={onKillSession}
              disabled={killingSession}
            >
              {killingSession ? (
                <>
                  <span className="btn-kill-spinner"></span>
                  Killing...
                </>
              ) : 'Kill Session'}
            </button>
          )}
          <button
            className="btn-primary"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};
